import React from "react";
import styled from "styled-components";
import { device } from "../lib/breakpoints";

const PageHeader = ({
  title,
  subtitle,
  icon: Icon,
  className = "",
  /** On wide viewports, keep subtitle on a single line (e.g. OpsChat settings). */
  subtitleOnOneLine = false,
}) => {
  return (
    <Header
      className={[className, "clumse-page-header"].filter(Boolean).join(" ")}
    >
      <HeaderContent>
        <div className="header-text-container">
          <Title $compactIconGap={Boolean(Icon?.isCustomLogo)}>
            {Icon &&
              // Check if this is a custom logo component or a function component
              (Icon.isCustomLogo ? (
                <Icon />
              ) : typeof Icon === "function" && Icon.length === 0 ? (
                // Function component that returns JSX
                <Icon />
              ) : (
                <Icon
                  style={{
                    fontSize: "1.5rem",
                    color: "#ffffff",
                    flexShrink: 0,
                  }}
                />
              ))}
            <TitleText>{title}</TitleText>
          </Title>
          {subtitle ? (
            <Subtitle $singleLine={subtitleOnOneLine}>{subtitle}</Subtitle>
          ) : null}
        </div>
      </HeaderContent>
    </Header>
  );
};

export default PageHeader;

// Styled Components: solid forest green bar; subtitle stacked below title
const Header = styled.div`
  background: var(--color-primary);
  border-radius: 20px;
  padding: 1.25rem 2rem;
  margin-bottom: 1.5rem;
  color: white !important;
  box-shadow: 0 6px 24px rgba(44, 95, 45, 0.22);
  border: 1px solid rgba(255, 255, 255, 0.14);
  position: relative;
  overflow: hidden;
`;

const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  .header-text-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.4rem;
    flex: 1;
    min-width: 0;
    text-align: left;

    @media (max-width: 768px) {
      align-items: stretch;
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
  }
`;

const TitleText = styled.span`
  min-width: 0;
  flex: 1;
  line-height: 1.2;
  overflow-wrap: anywhere;
  font-size: inherit;
  font-weight: 700;
  color: #ffffff;
`;

const Title = styled.h1`
  font-family: var(--font-primary);
  font-size: 1.875rem;
  font-weight: 700;
  margin: 0;
  color: #ffffff;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
  letter-spacing: -0.02em;
  line-height: 1.2;
  position: relative;
  z-index: 1;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  column-gap: ${({ $compactIconGap }) =>
    $compactIconGap ? "6px" : "12px"};
  row-gap: 4px;
  width: 100%;
  min-width: 0;
  text-align: left;

  .anticon {
    color: #ffffff !important;
  }

  img {
    display: inline-block;
    vertical-align: middle;
  }

  @media (max-width: 1200px) {
    font-size: 1.75rem;
  }

  @media (max-width: 768px) {
    font-size: clamp(1.35rem, 4vw, 1.65rem);
    flex-wrap: nowrap;
    align-items: center;
    justify-content: flex-start;
  }
`;

const Subtitle = styled.p`
  font-family: var(--font-secondary);
  font-size: 1rem;
  margin: 0;
  max-width: 42rem;
  color: rgba(255, 255, 255, 0.92);
  font-weight: 400;
  letter-spacing: -0.01em;
  line-height: 1.45;
  position: relative;
  z-index: 1;
  align-self: stretch;
  text-align: left;

  @media (min-width: 769px) {
    ${(p) =>
      p.$singleLine
        ? `
      white-space: nowrap;
      max-width: none;
      font-size: 0.9rem;
      letter-spacing: -0.02em;
    `
        : ""}
  }

  @media (max-width: 768px) {
    max-width: 100%;
    font-size: 0.9375rem;
  }
`;

